import {
  ADD_QUESTION_BLOGS,
  ADD_DESCRIPTION_BLOGS,
  ADD_DATE_BLOGS,
  ADD_TAGS_BLOGS,
  ADD_CATEGORY_BLOGS,
  ADD_COMMENTS_BLOGS,
  ADD_CATEGORY_BLOGS_STATUS,
  ADD_BLOG_CONTENT,
  ADD_BLOG_COVER_IMAGE,
  GET_CATEGORY_FROM_API,
  FETCH_CATEGORY_FROM_API,
  REMOVE_BLOG_COVER_IMAGE,
  GET_SINGLE_POST_DATAS,
  EDIT_QUESTION_BLOGS,
  EDIT_DESCRIPTION_BLOGS,
  EDIT_BLOG_CONTENT,
  EDIT_IS_COMMENT,
  EDIT_TAGS_BLOGS,
  REMOVE_HEAD_IMAGE_BLOGS,
  EDIT_HEAD_IMAGE_BLOGS,
  FETCH_CATEGORY_FROM_API_EDIT,
  EDIT_CATEGORY_BLOGS_STATUS,
  EMPTY_BLOG_EDIT_STATE,
  IS_FETCHED_BLOG,
  RESET_BLOG_CONTENT,
  CLEAR_IMAGE_BLOG
} from "../constants";

const initialBlogData = {
  question: "",
  description: "",
  datePublished: "",
  headImage: "",
  category: [],
  categoryStore: [],
  tags: [],
  isComment: true,
  active: true,
  content: "",
  blogFile: "",

  isFetchCat: false,
  blogPostID: "",
  editQuestion: "",
  editDescription: "",
  editHeadImage: "",
  editTags: "",
  editIsComment: true,
  editContent: "",
  editBlogFile: "",
  isSingleDataFetch: false,
  editCategory: [],
  editCategoryStore: [],
  isFetchedBlogData: false,
  blogProfile: "",
  blogUserName: "",
  isEditCategoryFetch : false,
};

const blogData = (state = initialBlogData, action) => {
  switch (action.type) {
    case ADD_QUESTION_BLOGS: {
      state.question = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_DESCRIPTION_BLOGS: {
      state.description = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_DATE_BLOGS: {
      state.datePublished = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_TAGS_BLOGS: {
      state.tags = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_CATEGORY_BLOGS: {
      var newCat = [...state.category];
      newCat.push({
        value: action.payload.value,
        status: true,
      });
      return {
        ...state,
        category: newCat,
      };
    }
    case ADD_COMMENTS_BLOGS: {
      state.isComment = !state.isComment;
      return {
        ...state,
      };
    }
    case ADD_CATEGORY_BLOGS_STATUS: {
      var catList = [...state.category];
      var catStore = [...state.categoryStore];
      var indexOf = catStore.findIndex(x => x.value === action.payload.value.value)
      if (action.payload.bool === true) {
        if (catList.length >= 3) {
          alert("reached Maximum");
        } else {
          catList.push(action.payload.value.value);
          catStore[indexOf].status = true;
        }
      }
      if (action.payload.bool === false) {
        catList.map((catItem) => {
          if (action.payload.value.value === catItem) {
            var indexToRemove = catList.indexOf(catItem);
          }
          return catList.splice(indexToRemove, 1);
        });
        catStore.map((listOfCate) => {
          return action.payload.value.value === listOfCate.value
            ? (listOfCate.status = false)
            : "";
        });
      }
      return {
        ...state,
        category: catList,
      };
    }
    case GET_CATEGORY_FROM_API: {
      return {
        ...state,
        categoryStore: action.payload?.map((list) => {
          return {
            value: list,
            status: false,
          };
        }),
      };
    }
    case ADD_BLOG_CONTENT: {
      state.content = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_BLOG_COVER_IMAGE: {
      var file = action.payload.target.files[0];
      {
        file
          ? (state.headImage = URL.createObjectURL(file))
          : (state.headImage = "");
      }
      {
        file ? (state.blogFile = file) : (state.blogFile = "");
      }
      return {
        ...state,
      };
    }
    case FETCH_CATEGORY_FROM_API: {
      return {
        ...state,
        isFetchCat: true,
      };
    }
    case REMOVE_BLOG_COVER_IMAGE: {
      return {
        ...state,
        blogFile: "",
        headImage: "",
      };
    }
    case GET_SINGLE_POST_DATAS: {
      var postData = action.payload;
      var editCategoryList = postData.category.map((list) => {
        return {
          value: list,
          status: true,
        };
      });
      state.blogProfile = action.payload.profile_photo
      state.blogUserName = action.payload.username
      return {
        ...state,
        blogPostID: postData.id,
        editQuestion: postData.title,
        editDescription: postData.description,
        editHeadImage:
          postData.banner_image === null ? "" : postData.banner_image,
        editTags: postData.tags,
        editIsComment: postData.comment_status === "1" ? true : false,
        editContent: postData.content,
        editBlogFile: "",
        editCategory: postData.category,
        editCategoryStore: editCategoryList,
      };
    }
    // EDIT
    case EDIT_QUESTION_BLOGS: {
      return {
        ...state,
        editQuestion: action.payload,
      };
    }
    case EDIT_DESCRIPTION_BLOGS: {
      return {
        ...state,
        editDescription: action.payload,
      };
    }
    case EDIT_BLOG_CONTENT: {
      return {
        ...state,
        editContent: action.payload,
      };
    }
    case EDIT_IS_COMMENT: {
      return {
        ...state,
        editIsComment: !state.editIsComment,
      };
    }
    case EDIT_TAGS_BLOGS: {
      return {
        ...state,
        editTags: [...action.payload],
      };
    }
    case REMOVE_HEAD_IMAGE_BLOGS: {
      return {
        ...state,
        editBlogFile: "DELETE",
        editHeadImage: "",
      };
    }
    case EDIT_HEAD_IMAGE_BLOGS: {
      var file = action.payload.target.files[0];
      file
        ? (state.editHeadImage = URL.createObjectURL(file))
        : (state.editHeadImage = "");
      file ? (state.editBlogFile = file) : (state.editBlogFile = "");
      return {
        ...state,
      };
    }
    case FETCH_CATEGORY_FROM_API_EDIT: {
      if(state.isEditCategoryFetch === false){
        state.isEditCategoryFetch = true
        var prevEditCategoryStore = [...state.editCategoryStore];
        var editCategoryList = action.payload.map((list) => {
          return {
            value: list,
            status: false,
          };
        });
        var arrFin = []
        editCategoryList.map((items) => {
          for (let i = 0; i < prevEditCategoryStore.length; i++) {
            if (items.value === prevEditCategoryStore[i].value) {
              arrFin.push({ value: items.value, status: true })
              return arrFin;
            }
          }
          arrFin.push(items)
          return arrFin;
        })
        return {
          ...state,
          editCategoryStore: [...arrFin],
        };
      }else{
        return {...state}
      }
    }
    case EDIT_CATEGORY_BLOGS_STATUS: {
      var catList = [...state.editCategory];
      var catStore = [...state.editCategoryStore];
      var indexOf = catStore.findIndex(x => x.value === action.payload.value.value)
      if (action.payload.bool === true) {
        if (catList.length >= 3) {
          alert("Maximum Reached");
        } else {
          catList.push(action.payload.value.value);
          catStore[indexOf].status = true;
        }
      }
      if (action.payload.bool === false) {
        catList.map((catItem) => {
          if (action.payload.value.value === catItem) {
            var indexToRemove = catList.indexOf(catItem);
            return catList.splice(indexToRemove, 1);
          }
        });
        catStore.map((listOfCate) => {
          if (action.payload.value.value === listOfCate.value) {
            return (listOfCate.status = false);
          }
        });
      }
      return {
        ...state,
        editCategory: catList,
      };
    }
    case EMPTY_BLOG_EDIT_STATE: {
      return {
        ...state,
      };
    }
    case IS_FETCHED_BLOG: {
      state.isFetchedBlogData = action.payload;
      return {
        ...state,
      };
    }
    case RESET_BLOG_CONTENT: {
      state.question = "";
      state.description = "";
      state.headImage = "";
      state.content = "";
      state.category = [];
      state.tags = [];
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
export default blogData;
